import Labs from "./Labs";
import AddLabs from "./AddLabs";

export default Labs;
export { AddLabs };
